<template>
  <v-dialog v-model="value" max-width="700" persistent scrollable>
    <v-form
      @submit.prevent="save()"
      ref="form"
      :lazy-validation="true"
      :disabled="isLoading"
    >
      <v-card>
        <v-card-title
          class="
            d-flex
            justify-space-between
            align-center
            blue
            white--text
            py-2
          "
        >
          {{ $t('payment.bank_account') }}
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text class="py-5">
          <v-row>
            <v-col cols="12" class="py-1">
              <span>{{ $t('payment.select_bank_account') }}</span>
              <v-autocomplete
                :items="bankDataOptions"
                v-model="formData.bankCode"
                item-text="name"
                item-value="code"
                flat
                background-color="grey lighten-4"
                solo
                :label="$t('payment.select_bank_account')"
                :rules="[rules.required]"
              >
                <template v-slot:selection="{ item }">
                  <v-list-item-avatar class="mx-0 my-0">
                    <v-img
                      :src="require(`../assets/images/bank/${item.code}.jpg`)"
                      max-width="35"
                      max-height="35"
                    />
                  </v-list-item-avatar>
                  <span class="ms-3">{{ item.name }}</span>
                </template>
                <template v-slot:item="{ item }">
                  <template>
                    <v-list-item-avatar>
                      <v-img
                        :src="require(`../assets/images/bank/${item.code}.jpg`)"
                      />
                    </v-list-item-avatar>
                    <v-list-item-content>
                      <v-list-item-title>{{ item.name }}</v-list-item-title>
                    </v-list-item-content>
                  </template>
                </template>
              </v-autocomplete>
            </v-col>
            <v-col cols="12" class="py-1">
              <span>{{ $t('payment.account_name') }}</span>
              <v-text-field
                v-model="formData.accountName"
                flat
                background-color="grey lighten-4"
                solo
                :label="$t('payment.account_name')"
                :rules="[rules.required]"
                required
              ></v-text-field>
            </v-col>
            <v-col cols="12" class="py-1">
              <span>{{ $t('payment.account_number') }}</span>
              <v-text-field
                v-model="formData.accountNumber"
                flat
                background-color="grey lighten-4"
                solo
                :label="$t('payment.account_number')"
                :rules="[rules.required]"
                required
              ></v-text-field>
            </v-col>
            <v-col cols="12" class="py-1">
              <span>{{ $t('payment.branch') }}</span>
              <v-text-field
                v-model="formData.accountBranch"
                flat
                background-color="grey lighten-4"
                solo
                :label="$t('payment.branch')"
                :rules="[rules.required]"
                required
              ></v-text-field>
            </v-col>
            <v-col cols="12" class="py-1">
              <span>{{ $t('accounting_product.code') }}</span>
              <v-text-field
                v-model="formData.erpCode"
                flat
                background-color="grey lighten-4"
                solo
                :label="$t('accounting_product.code')"
                hide-details
              ></v-text-field>
            </v-col>
            <v-col cols="12" class="py-1 ps-4">
              <v-checkbox
                v-model="formData.isShowCustomer"
                flat
                solo
                :label="$t('market.show_to_trader')"
                hide-details
                @click="formData.selectedMarketIds = []"
              ></v-checkbox>
            </v-col>
            <v-col cols="12" class="py-2 ps-4" v-if="formData.isShowCustomer">
              <span>{{ $t('market.select_market_to_show') }}</span>
              <v-autocomplete
                color
                v-model="formData.selectedMarketIds"
                :items="markets"
                :label="$t('market.market_seen_by_trader')"
                item-text="name"
                item-value="objectId"
                multiple
                flat
                background-color="grey lighten-4"
                solo
                required
                :rules="[rules.requiredArray]"
              >
                <template v-slot:prepend-item>
                  <v-list-item
                    ripple
                    @mousedown.prevent
                    @click="selectAll"
                  >
                    <v-list-item-action>
                      <v-icon :color="formData.selectedMarketIds.length > 0 ? 'primary' : ''">
                        {{ icon }}
                      </v-icon>
                    </v-list-item-action>
                    <v-list-item-content>
                      <v-list-item-title>
                        {{ $t('all') }}
                      </v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                  <v-divider class="mt-2"></v-divider>
                </template>
              </v-autocomplete>
            </v-col>
          </v-row>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions class="px-6">
          <v-spacer></v-spacer>
          <v-btn
            color="success"
            type="submit"
            elevation="0"
            :disabled="isLoading"
          >
            <v-icon left>mdi-content-save</v-icon>
            <span v-if="bankAccount">{{ $t('save') }}</span>
            <span v-else>{{ $t('payment.add_account') }}</span>
          </v-btn>
          <v-btn
            color="error"
            elevation="0"
            @click="dismiss()"
            :disabled="isLoading"
          >
            {{ $t('close') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-form>
  </v-dialog>
</template>

<script>
import BankData from "../json/bank-data.json";
import { mapState } from "vuex"
export default {
  props: {
    value: Boolean,
    projectId: String,
    bankAccount: Object,
  },
  data() {
    return {
      isLoading: false,
      bankDataOptions: [],
      markets: null,
      formData: {
        projectId: this.projectId,
        bankCode: "",
        accountName: "",
        accountNumber: "",
        accountBranch: "",
        erpCode: "",
        isShowCustomer: false,
        selectedMarketIds: []
      },
      rules: {
        required: (value) => !!value || this.$t('validate.please_input_data'),
        requiredArray: (value) => !!value.length || this.$t('validate.please_input_data'),
      },
    };
  },
  computed: {
    ...mapState({
      sessionAdmins: state => state.admin.sessionAdmins
    }),
    selectAllArea () {
      return this.formData.selectedMarketIds.length === this.markets.length
    },
    selectSomeArea () {
      return this.formData.selectedMarketIds.length > 0 && !this.selectAllArea
    },
    icon () {
      if (this.selectAllArea) return 'mdi-close-box'
      if (this.selectSomeArea) return 'mdi-minus-box'
      return 'mdi-checkbox-blank-outline'
    },
  },
  created() {
    for (let key in BankData) {
      this.bankDataOptions.push(BankData[key]);
    }
    this.markets = [];
    for (let admin of this.sessionAdmins) {
      if (this.projectId === admin.project.objectId) {
        this.markets.push(admin.market);
      }
    }
  },
  watch: {
    value() {
      if (this.$refs.form) this.$refs.form.resetValidation();
      if (this.bankAccount) {
        this.formData = {
          id: this.bankAccount.objectId,
          bankCode: this.bankAccount.bankCode,
          accountName: this.bankAccount.accountName,
          accountNumber: this.bankAccount.accountNumber,
          accountBranch: this.bankAccount.accountBranch,
          erpCode: this.bankAccount.erpCode,
          isShowCustomer: this.bankAccount.isShowCustomer,
          selectedMarketIds: this.bankAccount.selectedMarkets ? this.bankAccount.selectedMarkets.map(d => d.objectId) : []
        };
        if(this.bankAccount.isShowCustomer){
          if(this.bankAccount.selectedMarkets){
            this.formData.selectedMarketIds = this.bankAccount.selectedMarkets.map(d => d.objectId)
          }else{
            this.formData.selectedMarketIds = this.markets.map(d => d.objectId)
          }
        }
      } else {
        this.formData = {
          projectId: this.projectId,
          bankCode: "",
          accountName: "",
          accountNumber: "",
          accountBranch: "",
          erpCode: "",
          isShowCustomer: false,
          selectedMarketIds: []
        };
      }
    },
  },
  methods: {
    async save() {
      if (this.$refs.form.validate()) {
        this.isLoading = true;
        try {
          if(this.formData.selectedMarketIds && this.formData.selectedMarketIds.length){
            this.formData.isShowSelectedMarket = true
          }else{
            this.formData.isShowSelectedMarket = true
          }
          let bankAccount;
          if (this.formData.id)
            bankAccount = await this.$store.dispatch(
              "bankAccount/updateBankAccount",
              this.formData
            );
          else
            bankAccount = await this.$store.dispatch(
              "bankAccount/createBankAccount",
              this.formData
            );

          this.isLoading = false;
          this.$emit("onSaveSuccess", bankAccount);
          this.$emit("input", false);
        } catch (error) {
          this.$emit("onError", error);
          this.$emit("input", false);
          this.isLoading = false;
        }
      }
    },
    selectAll(){
      if (this.selectAllArea) {
        this.formData.selectedMarketIds = []
      } else {
        this.formData.selectedMarketIds = this.markets.map(d => d.objectId)
      }
    },
    dismiss() {
      this.$emit("input", false);
    },
  },
};
</script>

<style>
</style>